import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MarketingAnalyticsService } from '../../shared/services/analytics/marketing-analytics.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink],
})
export class CompanyComponent implements OnInit {
  currentYear = new Date().getFullYear();

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private readonly analytics: MarketingAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Naybrs — Commerce platform for physical goods, powered by AI');
    this.metaService.updateTag({
      name: 'description',
      content:
        'A commerce platform that makes physical-world inventory discoverable and purchasable. AI handles the operations that would normally require a team.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Naybrs — Commerce platform for physical goods, powered by AI',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'A commerce platform that makes physical-world inventory discoverable and purchasable. AI handles the operations that would normally require a team.',
    });
  }

  scrollToSection(sectionId: string): void {
    void this.analytics.trackSectionClick(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
